module.exports = __webpack_public_path__ + "img/SprayPainting4.7607c20a.jpg";